export const AdminActionTypes = {
  ADD_NEW_USER_PASS: "ADD_NEW_USER_PASS",
  ADD_NEW_USER_FAIL: "ADD_NEW_USER_FAIL",
  ADD_NEW_USER_READY: "ADD_NEW_USER_READY",
};
